import { Props } from '@service-victoria/component-library/components/ConfirmationModal';
import { noop } from 'lodash-es';
import React, { createContext } from 'react';

export type ModalItem = {
  title?: string;
  children?: React.ReactChild;
};

interface BaseModalOptions {
  loader?: React.ReactChild;
  cancel?: {
    text?: string;
    onClick?: () => void;
  };
}

export interface ConfirmationModalOptions extends BaseModalOptions {
  type: 'CONFIRMATION';
  confirmationOptions?: {
    canEscape?: boolean;
    actions?: Props.Interfaces.Action[];
  };
}

export interface SimpleModalOptions extends BaseModalOptions {
  type?: 'MODAL';
}

export type ModalOptions = ConfirmationModalOptions | SimpleModalOptions;
export interface ModalOpenFn {
  (config: ModalItem, options?: ModalOptions): void;
  (loadValues: () => Promise<ModalItem>, options?: ModalOptions): void;
}

type ModalCtx = {
  isOpen: boolean;
  open: ModalOpenFn;
  close: () => void;
};

const ModalContext = createContext<ModalCtx>({
  isOpen: false,
  open: noop,
  close: noop
});

export default ModalContext;
